import { Poster } from '../types/types';

export const posters: Poster[] = [
    {
        id: 'dom-rr-2025',
        title: "Division of Medicine Research Retreat 2025",
        description: "Simulations of basal stem cells in the upper airway of patients with three example smoking histories.",
        dataItems: [
            {
                id: "p-ir",
                title: "Protected & Immune Response hypotheses",
                data: {
                    type: "image",
                    url: "/assets/files/dom_rr_202505/protected-immune_response.gif"
                },
                description: "Protected regions of epithelium and smoking-suppressed immune response hypotheses activated."
            },
            {
                id: "q-sd",
                title: "Quiescent & Smoker Driver hypotheses",
                data: {
                    type: "image",
                    url: "/assets/files/dom_rr_202505/quiescent-smoking_driver.gif"
                },
                description: "Quiescent subpopulation and smoking-addicted drivers hypotheses activated."
            }
        ]
    }
]; 